<template>
  <div class="xxxxxx">
    <div class="xxxxxxbox" ref="printArea"></div>
    <!-- :style="'height:' + gaodus" -->
    <div class="head">
      <proHead></proHead>
    </div>
    <div class="proComFour" ref="printArea2">
      <div class="box">
        <!-- 左侧内容区 -->
        <div class="le">
          <div class="con wow fadeInUp">
            <div class="tle">
              <div class="t1 tit-48 montserMedium B-500 mt-110 buxianshi">
                {{gudingziduan.tuijian.pone4_1}}
              </div>
              <div class="t2 tit-16 ys-33 buxianshi">
               {{gudingziduan.tuijian.pone4_2}}
              </div>
              <div class="t3 tit-30 ys-33 montserMedium B-500 mt-86">
                {{gudingziduan.tuijian.pone4_3}} <i class="pl-10"></i>
              </div>
              <div
                class="t4 tit-16"
                style="color: #5E5E5E;"
                v-if="shu.powerType && shu.powerType.content"
              >
                {{ shu.powerType.content }}
              </div>
              <div class="t5 tit-16" style="color: #5E5E5E;">
                Maximum battery charging time: {{ shu.hour }} hours
              </div>
            </div>
            <!-- 逆变器产品 -->
            <div class="proInfo proInfonox" v-for="(n, i) in shu.inverterList">
              <div class="flex j-between tit-box">
                <div class="montserRegular tit-28 ys-33">{{ n.title }}</div>
                <div class="btncpxq wow cur_pointer buxianshi" @click="tiaozhuange(n.linkUrl)">
                  <i class="tit-15"> {{gudingziduan.tuijian.pone4_6}} </i>
                  <i class="iconfont icon-jinru1 tit-15"></i>
                </div>
              </div>
              <div class="flex box">
                <div class="imgBox">
                  <img
                    :src="'https://community.goodwe.com/' + n.image"
                    class="nbqtu"
                  />
                </div>

                <div class="con">
                  <div
                    v-for="(x, i) in n.attributes"
                    class="pt-20 pb-20 pr-70 flex j-between urlis"
                    style="border-bottom: 1px solid rgba(0,0,0,.1);"
                  >
                    <div class="tit-14">{{ x.name }}</div>
                    <div class="tit-14">{{ x.value }}</div>
                  </div>
                  <div
                    class="num mt-20 pr-70 quantity"
                    style="display: flex; justify-content: space-between;"
                  >
                    Quantity:
                    <span>{{ shu.inverterNum }}</span>
                  </div>
                </div>
              </div>
            </div>

            <div
              class="proBattery"
              v-if="shu.batteryList"
              v-for="(n, i) in shu.batteryList"
            >
              <div
                class="tit-30 ys-33 montserMedium B-500 mt-66 t-center Batterybiaotis"
                v-if="shu.batteryList"
              >
                 {{gudingziduan.tuijian.pone4_5}}
              </div>
              <!-- 电池产品 -->
              <div class="proInfo proInfonox2">
                <div class="flex j-between tit-box">
                  <div class="montserRegular tit-28 ys-33">{{ n.title }}</div>
                  <div class="btncpxq wow cur_pointer buxianshi" @click="tiaozhuange(n.linkUrl)">
                    <i class="tit-15"> {{gudingziduan.tuijian.pone4_6}} </i>
                    <i class="iconfont icon-jinru1 tit-15"></i>
                  </div>
                </div>
                <div class="flex box">
                  <div class="imgBox">
                    <img :src="n.image" class="nbqtu" />
                  </div>

                  <div class=" con">
                    <div
                      v-for="(x, i) in n.attributes"
                      class="pt-20 pb-20 pr-70 flex j-between urlis"
                      style="border-bottom: 1px solid rgb(0,0,0,.1);"
                    >
                      <div class="tit-14">{{ x.name }}</div>
                      <div class="tit-14">{{ x.value }}</div>
                    </div>
                    <div
                      class="num mt-20 pr-70 quantity"
                      style="display: flex; justify-content: space-between;"
                    >
                       {{gudingziduan.tuijian.pone4_4}}:
                      <span>{{ n.batteryNum }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="totalnum" v-for="(x, i) in deviceList">
              <div class="power">
                <span class="num">{{ x.Totalpower }}</span>
                <span class="dw"> {{gudingziduan.tuijian.pone3_8}} [W]</span>
              </div>
              <div class="wh">
                <span class="num">{{ x.Totalhour }}</span>
                <span class="dw">{{gudingziduan.tuijian.pone3_9}} [Wh]</span>
              </div>
            </div>

			<div class="tips">
				<div class="text">Note : If there are motorized devices, confirm their peak current does not exceed inverter limit.</div>
			</div>

            <!-- 操作按钮 -->
            <div class="more mb-80 anniuquyue">
              <div class="btn2 montserLight tit-18" @click="tijiao">
                {{gudingziduan.tuijian.pone4_3}}
              </div>
              <div class="btn2 montserLight tit-18 ml-30" @click="handlePrint">
                {{gudingziduan.tuijian.pone4_7}}
              </div>
            </div>
          </div>
        </div>
        <div class="re">
          <!-- 右侧内容区 -->

          <!-- 步骤条 -->
          <Steps :stpsActive="stpsVal"></Steps>
          <!-- 步骤条 end!!-->

          <div class="bom">
            <i class="iconfont icon-kongxinwenhao tit-26"></i>
            <div class="p1 tit-14 montserRegular mt-15 ys-28">
              {{gudingziduan.tuijian.pone2_4}}
            </div>
            <div class="p2 tit-12 mt-10 ys-6">
             {{gudingziduan.tuijian.pone2_5}}
            </div>
            <div class="bomUs" @click="tiaozhuang">{{gudingziduan.tuijian.pone2_6}}</div>
          </div>
        </div>
      </div>
    </div>
    <!-- </div> -->
  </div>
</template>
<script>
import { string } from "clipboard";
import proHead from "../../../components/proComSystem/header.vue";
import Steps from "../../../components/proComSystem/steps.vue";

import { getCalc } from "@/api/proComSystem.js";

export default {
  components: {
    proHead,
    Steps,
  },

  data() {
    return {
      stpsVal: 3, // 步骤条
      active: 0, // 默认选中样式
      radio: 0, // 默认选中类型
      lilist: [],
      loading: true, //加载
      deviceList: [],
      shu: {},
      devzonghour: 0,
      gaodus: "",
	  gudingziduan:{}
    };
  },
  watch: {
  		'$store.state.cunyuanyan': {
  		  handler(newValue, oldValue) {
  			// console.log('语言已更新:', newValue);
  			this.gudingziduan=this.$store.state.cunyuanyan
  			// console.log(this.gudingziduan,'video')
  		  },
  		  deep: true // 如果 cunyuanyan 是对象，需要设置 deep 为 true
  		}
  	},
  // 下一个页面 - 接收参数
  created() {
    // const data = this.$route.query.data  // 接收query参数
    // 或者接收params:
    // const data = this.$route.query.data
    // console.log(data);
  },
  mounted() {
    new this.$wow.WOW({
      live: false,
    }).init();
    this.deviceList = this.$qu("deviceList");

    console.log(this.deviceList);

    // this.devzonghour=this.deviceList.reduce((sum, item) => sum + item.hour, 0);
    if (this.$qu("powerTypeId") && this.deviceList.length > 0) {
      getCalc({
        deviceList: this.deviceList,
        powerTypeId: this.$qu("powerTypeId"),
      }).then((s) => {
        if (s.code != 200) {
          this.$message({
            showClose: true,
            iconClass: "el-icon-warning",
            customClass: "my-error-message2",
            message: s.message,
            type: "error",
            offset: "350",
            duration: 0,
          });
        } else {
          this.shu = s.data;
        }
      });
    }
    window.addEventListener("afterprint", this.handlePrint1); // 监听打印完成事
	this.$store.commit('Gaiyuyan', this.$store.state.yuyan);
	this.gudingziduan=this.$store.state.cunyuanyan
  },
  computed: {},
  methods: {
    tijiao() {
      // this.$cun("deviceList", []);
      this.$dakai("/proComThre");
    },
    handlePrint() {
      const carouselItem = this.$refs.printArea;
      const carouselItem2 = this.$refs.printArea2;
      if (carouselItem) {
        carouselItem.style.height = `${carouselItem2.offsetHeight}px`;
      }
      window.print();
    },
    tiaozhuang() {
      window.open("https://en.goodwe.com/contact-us");
    },
	tiaozhuange(e) {
		window.open(e);
	},
    handlePrint1() {
      const carouselItem = this.$refs.printArea;
      if (carouselItem) {
        carouselItem.style.height = `0px`;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.xxxxxxbox {
  background: url("../../../assets/shuiyin.png") !important;
  background-repeat: repeat !important;
  /* 重复显示图片 */
  // background-attachment: fixed !important;
  /* 固定水印位置，不随内容滚动 */
  // background-size: 180px 80px !important;

  background-size: 180px 80px !important;
  /* 保持图片原始尺寸 */
  pointer-events: none !important;
  /* 不影响内容交互 */
  z-index: 9999;
  /* 确保水印在最上层 */
  width: 100%;
  height: 100%;
  // position: fixed;
  // top: 0;
  // left: 0;
  box-shadow: none !important;
  box-sizing: border-box;

  // display: none;
}

// 主体布局
.proComFour {
  position: relative;
  background: url("../../../assets/pc/proComSystem/proComTwo-bj.png") no-repeat
    center;
  background-size: cover;

  > .box {
    // height: 100vh;
    display: flex;
  }

  .le {
    width: 85%;
  }

  .re {
    width: 15%;
    min-width: 200px;
    background: #ececec;
  }
}

// 内容区左侧
.proComFour .le {
  box-sizing: border-box;
  padding: 0 10%;
  display: flex;
  align-items: center;
  justify-content: center;

  .proInfo {
    width: 83%;
    max-width: 1028px;
    margin: auto;
    min-height: 4rem;
    padding: 0.48rem 0.39rem 0.63rem 0.58rem;
    margin-top: 0.3rem;
    box-sizing: border-box;
    // background: linear-gradient(41deg, #ffffff 0%, #dbdbdb 100%);
    background: linear-gradient(306deg, #f3f3f3, #d5d5d5);
    border-radius: 0.3rem;
    box-shadow: 0.05rem 0.09rem 0.16rem 0.1rem rgba(0, 0, 0, 0.02);

    .btncpxq {
      padding: 0.14rem 0.18rem;
      color: #fff;
      background: linear-gradient(94deg, #ff785c 0%, #e70a16 100%);
      border-radius: 100px;
      display: inline-block;
    }

    .box {
      justify-content: space-between;
      align-items: center;
      margin-top: 0.5rem;
    }

    .box .imgBox {
      width: 45%;
      text-align: center;
    }

    .box .con {
      width: 50%;
    }

    .box .con .urlis {
      padding: 0.2rem;
    }

    .box .con .urlis > div.tit-14 {
      font-size: var(--font18);
    }

    .box .con .quantity {
      font-weight: 700;
      font-size: var(--font20);
      margin: 0;
      background: linear-gradient(94deg, #ff785c 0%, #e70a16 100%);
      color: #fff;
      padding: 0.15rem 0.2rem;
      border-radius: 0.1rem 0.1rem 0.2rem 0.1rem;
    }

    .nbqtu {
      max-width: 100%;
      max-height: 3rem;
    }

    .hide {
      padding: 0.2rem;
      background: #fdfdfd;
      border-radius: 0.15rem;
    }
  }

  .con {
    width: 100%;

    .tle {
      text-align: center;

      h3 {
      }

      span {
        display: block;
        margin-top: 0.1rem;
      }
    }

    ul {
      margin: 0 -0.3rem;
      margin-top: 0.75rem;
      display: flex;
      justify-content: center;
      flex-wrap: wrap;

      li {
        width: 17%;
        margin: 0 0.15rem;
        position: relative;
        padding: 0 0.1rem;
        height: 4rem;
        background: linear-gradient(41deg, #ffffff 0%, #dbdbdb 100%);
        border-radius: 0.3rem;
        box-shadow: 0.05rem 0.09rem 0.16rem 0.1rem rgba(0, 0, 0, 0.02);
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        overflow: hidden;
        z-index: 1;
        cursor: pointer;

        span {
          display: block;
          color: #333333;
          line-height: 1.5;
          transition: 0.3s;
        }
      }

      li::after {
        content: "";
        position: absolute;
        width: 100%;
        height: 100%;
        background: linear-gradient(0deg, #ff785c 0%, #e70a16 100%);
        left: 0;
        top: 0;
        opacity: 0;
        z-index: -1;
        transition: 0.5s;
      }

      // 选中样式
      li.isActive::after {
        opacity: 1;
      }

      li.isActive .icBox img {
        filter: brightness(100);
        -webkit-filter: brightness(100);
      }

      li.isActive span {
        color: #fff;
      }
    }
  }

  .totalnum {
    width: 100%;
    margin: auto;
    padding-top: 0.3rem;
    display: none;
  }

  .totalnum > div {
    display: flex;
    justify-content: space-between;
    margin: 5px 0;
    font-size: var(--font30);
  }

  .totalnum > div .num {
    color: #666;
  }

  .totalnum > div .dw {
    font-weight: 700;
  }

  .tips {display: none; width: 100%;margin: auto; padding-top: 0.3rem; color: #666;}
}

// 内容区右侧
.proComFour .re {
  padding: 0 0.3rem;
  padding-right: 0.2rem;
  padding-top: 2rem;
  box-sizing: border-box;
  min-height: 100vh;

  .bom {
    position: absolute;
    bottom: 5%;

    i {
      color: #e60012;
    }

    .p1 {
      color: #282828;
    }

    .bomUs {
      cursor: pointer;
      margin-top: 0.2rem;
      display: inline-block;
      background: #f9fafb;
      border: 1px solid #d1d5dc;
      font-family: "montserRegular";
      border-radius: 50px;
      font-size: 12px;
      padding: 0.11rem;
      transition: 0.5s;

      &:hover {
        background: #e60012;
        color: #fff;
        border-color: #e60012;
      }
    }
  }
}

// 底部按钮
.more {
  display: flex;
  justify-content: center;
  margin-top: 0.9rem;

  > div {
    cursor: pointer;
    transition: 0.5s;
    border-radius: 50px;
  }

  .btn1 {
    padding: 0.16rem 0.48rem;
    border: 1px solid #bebebe;
    color: #333;
    margin-right: 0.2rem;

    &:hover {
      background: #e70a16;
      border-color: #e70a16;
      color: #fff;
    }
  }

  .btn2 {
    padding: 0.16rem 0.35rem;
    background: linear-gradient(-71deg, #e70a16 0%, #ff785c 100%);
    color: #fff;

    &:hover {
      box-shadow: 0 0 0.1rem #e70a16;
    }
  }
}
// 单选框样式修改
.el-radio {
  position: absolute;
  right: 0.2rem;
  top: 0.23rem;
  opacity: 0;
  background: #ffffff;
  border-radius: 0.07rem;
  margin: 0;
  transition: 0.5s;
}

.el-radio.is-checked {
  opacity: 1;
}

::v-deep .el-radio__input {
  width: 0.28rem;
  height: 0.28rem;
  border: 0;
  opacity: 0;
}

::v-deep .el-radio__input.is-checked {
  background: #fff;
}

::v-deep .el-radio__label {
  position: absolute;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  top: 0;
  left: 0;
  padding: 0;
  justify-content: center;
}

// loading样式修改
::v-deep .el-loading-spinner .path {
  stroke: #e70a16 !important;
}

// 打印
@media print {
  @page {
    size: landscape !important;
    /* 边距 上右下左 */
    margin: 1cm;
  }
  body {
    pageorientation: landscape; /*设置默认方向*/
  }
  /* 打印时重置所有默认样式 */
  * {
    -webkit-print-color-adjust: exact;
    -moz-print-color-adjust: exact;
    -ms-print-color-adjust: exact;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
    border: none !important;
    outline: none !important;
    box-shadow: none !important;
    box-sizing: border-box;
  }

  /* 隐藏所有不需要打印的元素 */
  .proComFour .re,
  .head,
  .anniuquyue,
  .buxianshi {
    display: none !important;
  }

  /* 确保打印区域正常显示 */
  .proComFour {
    display: block !important;
    visibility: visible !important;
    min-height: 100vh !important;
    page-break-inside: avoid !important;
    background: none !important;
  }

  .xxxxxxbox {
    background: url("../../../assets/shuiyin.png") !important;
    background-repeat: repeat !important;
    // background-size: 300px 117px !important; /* 调整后尺寸（接近原始比例924:361） */
    /* 保持图片原始尺寸 */
    pointer-events: none !important;
    /* 不影响内容交互 */
    background-size: 35% !important;
    z-index: 0 !important;
    width: 100% !important;
    height: 100% !important;
    position: fixed;
    top: 0;
    left: 0;
    box-shadow: none !important;
    box-sizing: border-box;
  }

  .proInfo {
    page-break-inside: avoid !important;
    /* 防止单个.proInfonox 内部被分页 */
  }

  // .proInfo:nth-child(2n) {
  // 	page-break-after: always !important; /* 每两个.proInfonox 后强制分页 */
  // }

  .proBattery {
  }

  /* 强制打印区域内的图片显示 */
  .fadeInUp img {
    max-width: 100% !important;
    height: auto !important;
    display: block !important;
  }

  .proComFour .le {
    box-sizing: border-box !important;
    // padding: 0 10%;
    margin: 0 auto !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;

    .proInfo {
      width: 100% !important;
      margin: 0 auto !important;
	  margin-top: .3rem !important;
      padding: 0.5rem !important;
      box-sizing: border-box !important;
      background: linear-gradient(306deg, #f3f3f3, #d5d5d5) !important;
      border-radius: 0.3rem !important;
      box-shadow: 0.05rem 0.09rem 0.16rem 0.1rem rgba(0, 0, 0, 0.02) !important;

      .urlis {
        border-bottom: 1px solid rgba(0, 0, 0, 0.1) !important;
        padding: .15rem 0.2rem !important;
        display: flex 0.7rem !important;
        justify-content: space-between !important;
      }

      .tit-box > div {
        width: 100%;
        text-align: center;
      }

      .Batterybiaotis {
        padding-top: 0.3rem !important;
      }

      .box {
        justify-content: space-between !important;
        align-items: center !important;
        margin-top: 0.5rem !important;
      }

      .box .imgBox {
        width: 40% !important;
        text-align: center;
      }

      .box .con {
        width: 55% !important;
      }

      .nbqtu {
        max-width: 100% !important;
        max-height: 3rem !important;
      }

      .hide {
        padding: 0.2rem !important;
        background: #fdfdfd !important;
        border-radius: 0.15rem !important;
      }
    }

    .totalnum {
      margin-top: 0.5rem;
      display: block !important;
    }

	.tips {display: block; font-size: 20px;}
  }
}

// 打印 纵向
@media print and (orientation: portrait) {
  .proComFour .le .con .tle .t3 {
	margin-top: 20px;
    font-size: 26px;
  }
  .proComFour .le .con .tle .t4 {
    font-size: 20px;
  }
  .proComFour .le .con .tle .t5 {
    font-size: 20px;
  }
  .proComFour .le {
    width: 100%;
  }

  .proComFour .le .proInfo {
    padding: 0.25rem !important;
    width: 80% !important;
    margin: auto;
  }

  .proComFour .le .proInfo .tit-box {
    flex-wrap: wrap !important;
  }

  .proComFour .le .proInfo .tit-box > div {
    width: 100% !important;
    text-align: center !important;
  }

  .proComFour .le .proInfo .box {
    flex-wrap: wrap !important;
  }

  .proComFour .le .proInfo .box .imgBox {
    width: 100% !important;
    margin: auto !important;
    text-align: center !important;
    display: flex;
    justify-content: center;
  }

  .proComFour .le .proInfo .box .con {
    width: 100% !important;
    margin-top: 0.3rem !important;
  }

  .proComFour .le .proInfo .tit-box > div {
    font-size: 24px;
  }

  .proComFour .le .proInfo .box .con .urlis > div.tit-14 {
    font-size: 16px;
  }

  .proComFour .le .proInfo .box .con .quantity {
    font-size: 18px;
  }

  .proComFour .le .proBattery .Batterybiaotis {
    font-size: 30px;
  }
  .proComFour .le .totalnum {
    width: 80%;
  }
  .proComFour .le .totalnum > div {
    font-size: 18px;
	
  }

  .tips {font-size: 14px; width: 80% !important; margin: auto;}



}

// ==========================================================================================================================================================================
// 响应式
@media screen and (max-width: 1024px) {
  .proComFour .le .proInfo {
    width: 100%;
  }
}

@media screen and (max-width: 767px) {
  .proConHead {
    background: #f9fafb;
  }

  .proComFour > .box {
    flex-wrap: wrap;
  }

  .proComFour .le {
    width: 100%;
  }

  .proComFour .re {
    width: 100%;
    display: none;
  }

  .proComFour .le .con .tle {
    margin-top: 2rem;
  }

  .proComFour .le .proInfo {
    padding: 0.5rem;
  }

  .proComFour .le .proInfo .tit-box {
    flex-wrap: wrap;
  }

  .proComFour .le .proInfo .tit-box > div {
    width: 100%;
    text-align: center;
  }

  .proComFour .le .proInfo .tit-box .buxianshi {
    width: auto;
    margin: auto;
    margin-top: 0.2rem;
  }
  .proComFour .le .proInfo .box .con .urlis > div.tit-14 {
	font-size: var(--font14);
 }
 .proComFour .le .proInfo .box .con .quantity {
	font-size: var(--font14);
 }
  .proComFour .le .proInfo .box {
    flex-wrap: wrap;
  }

  .proComFour .le .proInfo .box .imgBox {
    width: 80%;
    margin: auto;
    text-align: center;
  }

  .proComFour .le .proInfo .box .con {
    width: 100%;
    margin-top: 0.3rem;
  }

  .proComFour .le .proInfo .box .con > div {
    padding-right: 0;
  }

  .proComFour .le .con .more.anniuquyue .btn2.ml-30 {
    display: none;
  }
}
</style>
